import { gql } from '@apollo/client';

export const USERS_CLINIC_ADMIN_LIST = gql`
  query listUsersClinicAdmin($filter: String) {
    listUsersClinicAdmin(filter: $filter) {
      data {
        id
        email
        nameFirst
        nameLast
        active
        emailVerified
        role {
          id
          name
          nameDisplay
          permissions
        }
        acl {
          clinicId
          clinics
        }
      }
    }
  }
`;

export const USERS_CLINICIAN_LIST = gql`
  query listUsersClinician($filter: String) {
    listUsersClinician(filter: $filter) {
      data {
        id
        email
        nameFirst
        nameLast
        active
        emailVerified
        role {
          id
          name
          nameDisplay
          permissions
        }
        acl {
          clinicId
          clinics
          clinicianId
        }
      }
    }
  }
`;
